import { Injectable, OnInit } from '@angular/core';
import { AuthentService } from 'src/app/Services/authent.service';
import { CommonService } from 'src/app/Services/common.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Injectable({
  providedIn: 'root'
})
export class UserService implements OnInit {

  constructor(
    private commonService: CommonService,
    private errorHandlingService: ErrorHandlingService,
    private shareDataService: SharingDataService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private authentService : AuthentService,

  ) {
    this.shareDataService.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

  resourceDefinition;

  ngOnInit() {

  }

  getGipServicesUrl() {
    return this.commonService.getGipServicesUrl();
  }

  async getData(urls: string[], CallbackFunction) {
    this.authentService.getToken().then(async token => {
      const responses = await Promise.all(urls.map(url => fetch(this.commonService.getGipServicesUrl() + url, {
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      })));

      const results = new Array();

      for (const res of responses) {
        if(res.status === 401 && localStorage.getItem("access_token") != null){
          var getRefreshToken = await this.authentService.getRefreshToken();
          this.getData(urls, CallbackFunction);
        }
        const data = await res.json();
        results.push(data.value);
      }

      CallbackFunction(results);
    })
  }

  async getNonOData(urls: string[], CallbackFunction) {
    const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url)));
    CallbackFunction(responses);
  }

  async postData(url: string, data: any, CallbackFunction: (any) => any, ErrorCallbackFunction?: (response: Response) => any) {
    this.authentService.getToken().then(async token => {
      fetch(`${this.getGipServicesUrl()}${url}`, {
        method: 'POST', body: JSON.stringify(data), headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Authorization" : `Bearer ${token}`
        }
      })
        .then(async response => {
          if(response.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.authentService.getRefreshToken();
            this.postData(url, data, CallbackFunction, ErrorCallbackFunction);
          }
          if(response.status === 422){
            this.errorHandlingService.showError(this.translateResourceDefinition.transform('recaptchaFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
            return;
          }
          if (response.status < 200 || response.status > 299) {
            if (ErrorCallbackFunction != undefined)
              ErrorCallbackFunction(response);

            this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
            console.error(response);
            return;
          }
          this.errorHandlingService.showSuccess(undefined, undefined);
          CallbackFunction(response);
        })
        .catch(err => {
          console.error(err);
        });
    })
  }
}
